module.exports = __webpack_public_path__ + "./20e9eff56840a02f9c11374dba18d1ad-icon-service-default-large@2x.png";


//////////////////
// WEBPACK FOOTER
// ./plugins/services/src/img/icon-service-default-large@2x.png
// module id = 1084
// module chunks = 0